<ng-template #itemTemplate #selectedItemTemplate let-item>
    {{ item.description }}
</ng-template>
